import { COUNTRY_CODES } from "../../constants/countries";

export const MENU_VISIBILITY_BY_COUNTRY = {
    [(COUNTRY_CODES as any).ECUADOR]: {
        hide: ["2.9"],
    },
    [(COUNTRY_CODES as any).PARAGUAY]: {
        hide: ["2.9"], // 2.9 Oculta "Vendedores"
    },
    [(COUNTRY_CODES as any).HONDURAS]: {
        hide: [],
    },
    [(COUNTRY_CODES as any).ELSALVADOR]: {
        hide: ["5.4"],
    },
};